import React, {useEffect, useState} from 'react';
import {Button, InputNumber, Modal} from "antd";
import {useAuth} from "../../providers/AuthProvider";
import {useTalent} from "../../providers/TalentProvider";

const ClientPreferredRateModal = ({isDisabled, isOpen, onClose, ...props}) => {
    const {auth} = useAuth();

    const {
        talent,
        isDisabled: isTalentActionDisabled,
        overrideClientPreferredRate,
    } = useTalent();

    const percentMarkup = talent.markup_multiplier ? (talent.markup_multiplier - 1) : auth.clientOrg()?.defaultPercentMarkup()

    const beforeMarkup = (hourlyRate) => {
        return hourlyRate / (1+ percentMarkup)
    }
    const applyMarkUp = (hourlyRate) => {
        return hourlyRate * (1 + percentMarkup)
    }

    const [rate, setRate] = useState(talent.client_override_hourly_rate || talent?.standardPlatformRate(false));

    const [markedUpRate, setMarkedUpRate] = useState(talent.client_override_platform_rate || talent?.clientPreferredRate(false) || applyMarkUp(rate))

    useEffect(() => {
        if (!isOpen) {
            try {
                let defaultRate = talent.client_override_hourly_rate || talent?.standardPlatformRate(false)
                setRate(defaultRate);
            }catch (e) {
                console.warn('ERROR: unmount')
            }
        }
    }, [isOpen]);

    const onChangeRate = async (value) => {
        await setRate(value)
        setMarkedUpRate(Math.ceil(parseFloat(applyMarkUp(value).toFixed(2))))
    }
    const onChangeMarkedUpRate = async (value) => {
        await setMarkedUpRate(value)
        setRate(beforeMarkup(value))
    }

    if (!talent || !auth.canManageClients()) {
        return null;
    }

    return (
        <Modal
            title={'Set Client Preferred Rate for ' + talent.fullName()}
            footer={null}
            open={isOpen}
            width={800}
            onCancel={e => onClose(false)}
            afterClose={() => {
                setRate(talent.client_override_hourly_rate || talent?.standardPlatformRate(false));
            }}>
            <div>
                <div className="flex flex-row items-start flex-wrap gap-8 justify-evenly">
                    <span className="flex flex-col gap-1 items-stretch">
                        <label htmlFor="talent_preferred_rate" className="col-form-label">
                            Talent Payout Rate
                        </label>
                        <InputNumber
                            value={rate}
                            controls={false}
                            className="flex-1 min-w-24"
                            min="0"
                            name="talent_preferred_rate"
                            max="5000"
                            addonBefore="$"
                            addonAfter=" per hour "
                            precision={2}
                            onChange={onChangeRate}
                            formatter={value => Number(value)}
                        />
                    </span>
                    <span className="flex flex-col gap-1 items-stretch">
                        <label htmlFor="client_preferred_rate" className="col-form-label whitespace-nowrap">
                            Client Bill Rate
                        </label>
                        <InputNumber
                            value={markedUpRate}
                            controls={false}
                            readOnly
                            disabled
                            name="client_preferred_rate"
                            className="flex-1 min-w-24"
                            addonBefore="$"
                            addonAfter=" per hour "
                            precision={2}
                            onChange={onChangeMarkedUpRate}
                            formatter={value => Number(value)}
                        />
                        <span className="text-xxs italic whitespace-nowrap">
                            ({talent.markup_multiplier ? 'In-Network Talent' : 'Default'} {parseFloat((percentMarkup * 100).toFixed(2))}% markup applied, rounded up to nearest dollar)
                        </span>
                    </span>

                </div>
                <div className="flex flex-row items-center justify-end gap-3 mt-5">

                    <Button type="default" onClick={e => onClose(false)} disabled={isDisabled}>
                    Cancel
                    </Button>
                    <Button loading={isTalentActionDisabled}
                            disabled={isDisabled || !rate || rate <= 0}
                            type="primary"
                            onClick={async (e) => {
                                console.log('rate', rate)
                                await overrideClientPreferredRate(rate);

                                await TB.wait(200);
                                onClose(false)
                            }}>
                        Submit
                    </Button>
                </div>
            </div>
        </Modal>
    )
};

export default ClientPreferredRateModal;